module.exports = __webpack_public_path__ + "static/media/capitalsphere_sp1.b6c59197.svg";